import {hasPermission} from 'common/HelperFunctions'
import {USER_TYPES} from 'common/constants'
import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {MainReducer, RootState, UserReducer} from 'setup'

import {KTIcon} from '_metronic/helpers'

const ToolbarDashboard = () => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const userType = useSelector<RootState>(
    ({userReducer}) => userReducer.userType,
    shallowEqual
  ) as UserReducer['userType']
  const dashboardFilters = useSelector<RootState>(
    ({mainReducer}) => mainReducer.dashboard_filters,
    shallowEqual
  ) as MainReducer['dashboard_filters']

  const handleChange = (key: keyof MainReducer['dashboard_filters'], value: boolean) => {
    dispatch({
      type: 'SET_DASHBOARD_FILTERS',
      payload: {
        key,
        value,
      },
    })
  }

  useEffect(() => {
    dispatch({
      type: 'SET_DASHBOARD_FILTERS',
      payload: {
        key: 'activity',
        value: false,
      },
    })

    if (!dashboardFilters) {
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'hello',
          value: true,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'user_status',
          value: true,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'user_top_links',
          value: true,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'activity',
          value: false,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'attendance',
          value: true,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'accounting',
          value: false,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'fee',
          value: true,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'news',
          value: true,
        },
      })
      dispatch({
        type: 'SET_DASHBOARD_FILTERS',
        payload: {
          key: 'schedule',
          value: true,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!dashboardFilters) {
    return null
  }

  return (
    <div className='d-flex align-items-center gap-2 gap-lg-3'>
      <div className='m-0 dropdown'>
        <button
          type='button'
          className='btn btn-sm btn-flex btn-light btn-active-primary fw-bolder'
          data-bs-toggle='dropdown'
        >
          <KTIcon iconName='filter' className='fs-6 text-muted me-1' />
          {intl.formatMessage({id: 'ECOMMERCE.COMMON.FILTER'})}
        </button>

        <div
          className='menu menu-sub menu-sub-dropdown w-250px w-md-300px dropdown-menu'
          id='dashboard_filter_dropdown'
        >
          <div className='px-7 py-5 d-flex align-items-center justify-content-between'>
            <div className='fs-5 text-dark fw-bolder'>
              {intl.formatMessage({id: 'DASHBOARD.FILTER_WIDGET'})}
            </div>
          </div>

          <div className='separator border-gray-200'></div>
          <div className='scroll-y mh-325px px-7 py-5'>
            <div className='form-check form-switch mb-10'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='registered-users'
                checked={dashboardFilters.hello}
                onChange={(e) => handleChange('hello', e.target.checked)}
              />
              <label className='form-check-label fw-bold' htmlFor='registered-users'>
                {[USER_TYPES.TEACHER, USER_TYPES.PARENT, USER_TYPES.STUDENT].includes(userType)
                  ? intl.formatMessage({id: 'DASHBOARD.WELCOME'})
                  : intl.formatMessage({id: 'DASHBOARD.REGISTERED_USERS'})}
              </label>
            </div>

            {[USER_TYPES.ADMIN, USER_TYPES.STAFF].includes(userType) && (
              <div className='form-check form-switch mb-10'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='user-status'
                  checked={dashboardFilters.user_status}
                  onChange={(e) => handleChange('user_status', e.target.checked)}
                />
                <label className='form-check-label fw-bold' htmlFor='user-status'>
                  {intl.formatMessage({id: 'DASHBOARD.USER_STATUS'})}
                </label>
              </div>
            )}

            {(hasPermission('fee_manager') ||
              hasPermission('exam_manager') ||
              hasPermission('user_manager_students') ||
              hasPermission('user_manager_students') ||
              hasPermission('fee_manager_fee_collection')) && (
              <div className='form-check form-switch mb-10'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='top-user-link'
                  checked={dashboardFilters.user_top_links}
                  onChange={(e) => handleChange('user_top_links', e.target.checked)}
                />
                <label className='form-check-label fw-bold' htmlFor='top-user-link'>
                  {intl.formatMessage({id: 'DASHBOARD.TOP_LINKS'})}
                </label>
              </div>
            )}

            {[USER_TYPES.ADMIN, USER_TYPES.STAFF, USER_TYPES.TEACHER].includes(userType) && (
              <div className='form-check form-switch mb-10'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='activity'
                  checked={dashboardFilters.activity}
                  onChange={(e) => handleChange('activity', e.target.checked)}
                />
                <label className='form-check-label fw-bold' htmlFor='activity'>
                  {intl.formatMessage({id: 'DASHBOARD.ACTIVITIES'})}
                </label>
              </div>
            )}

            {hasPermission('attendance_manager') &&
              [USER_TYPES.ADMIN, USER_TYPES.STAFF].includes(userType) && (
                <div className='form-check form-switch mb-10'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    role='switch'
                    id='attendance'
                    checked={dashboardFilters.attendance}
                    onChange={(e) => handleChange('attendance', e.target.checked)}
                  />
                  <label className='form-check-label fw-bold' htmlFor='attendance'>
                    {intl.formatMessage({id: 'DASHBOARD.ATTENDANCE'})}
                  </label>
                </div>
              )}

            {/* {hasPermission('account_manager') && (
                  <div className='form-check form-switch mb-10'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      role='switch'
                      id='accounts'
                      checked={dashboardFilters.accounting}
                      onChange={(e) => handleChange('accounting', e.target.checked)}
                    />
                    <label className='form-check-label fw-bold' htmlFor='accounts'>
                      Accounts
                    </label>
                  </div>
                )} */}

            {hasPermission('fee_manager') &&
              [USER_TYPES.ADMIN, USER_TYPES.STAFF, USER_TYPES.TEACHER].includes(userType) && (
                <div className='form-check form-switch mb-10'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    role='switch'
                    id='fee'
                    checked={dashboardFilters.fee}
                    onChange={(e) => handleChange('fee', e.target.checked)}
                  />
                  <label className='form-check-label fw-bold' htmlFor='fee'>
                    {intl.formatMessage({id: 'DASHBOARD.FEE'})}
                  </label>
                </div>
              )}

            {hasPermission('news_manager') && (
              <div className='form-check form-switch mb-10'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='news'
                  checked={dashboardFilters.news}
                  onChange={(e) => handleChange('news', e.target.checked)}
                />
                <label className='form-check-label fw-bold' htmlFor='news'>
                  {intl.formatMessage({id: 'DASHBOARD.NEWS'})}
                </label>
              </div>
            )}

            {hasPermission('schedule_manager') && (
              <div className='form-check form-switch mb-10'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='schedule'
                  checked={dashboardFilters.schedule}
                  onChange={(e) => handleChange('schedule', e.target.checked)}
                />
                <label className='form-check-label fw-bold' htmlFor='schedule'>
                  {intl.formatMessage({id: 'DASHBOARD.SCHEDULE'})}
                </label>
              </div>
            )}

            {userType === USER_TYPES.TEACHER && (
              <div className='form-check form-switch mb-10'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  id='weeklySchedule'
                  checked={dashboardFilters.weeklySchedule}
                  onChange={(e) => handleChange('weeklySchedule', e.target.checked)}
                />
                <label className='form-check-label fw-bold' htmlFor='weeklySchedule'>
                  {intl.formatMessage({id: 'DASHBOARD.SCHEDULE.WEEKLY'})}
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export {ToolbarDashboard}
